import { useEffect, useState } from "react";

const LINKS = [
  { href: "#journey", label: "The Journey" },
  { href: "#host", label: "The Host" },
  { href: "#foundation", label: "The Foundation" },
  { href: "#testimonials", label: "Testimonials" },
];

const ZEFFY_URL = "https://www.zeffy.com/en-CA/ticketing/recalibrate-retreat-2";

export const MobileNavDrawer = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onClick = (e) => {
      if (e.target.closest('[data-testid="nav-mobile-toggle"]')) {
        setOpen((v) => !v);
      }
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  // Lock body scroll while open
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  // Close on ESC
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      {/* Backdrop */}
      <div
        data-testid="mobile-drawer-backdrop"
        aria-hidden={!open}
        onClick={() => setOpen(false)}
        className={`md:hidden fixed inset-0 z-[60] bg-[#2C3029]/60 backdrop-blur-sm transition-opacity duration-500 ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      />
      {/* Drawer */}
      <aside
        data-testid="mobile-drawer"
        aria-hidden={!open}
        role="dialog"
        aria-label="Site navigation"
        className={`md:hidden fixed top-0 right-0 z-[70] h-full w-[86%] max-w-[380px] bg-[#F4F1EA] shadow-2xl transform transition-transform duration-500 ease-out ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-7 pt-7 pb-6 border-b border-[#D4CFC4]/60">
          <span className="font-heading text-lg tracking-tight text-[#2C3029]">
            <span className="italic font-light">Recalibrate</span>
            <span className="ml-2 text-[10px] uppercase tracking-[0.3em] text-[#9E6D55]">Retreat</span>
          </span>
          <button
            data-testid="mobile-drawer-close"
            aria-label="Close menu"
            onClick={() => setOpen(false)}
            className="w-9 h-9 flex items-center justify-center text-[#2C3029] hover:text-[#9E6D55] transition-colors"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        <nav className="flex flex-col px-7 py-8">
          {LINKS.map((l, i) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`mobile-drawer-link-${l.href.slice(1)}`}
              onClick={() => setOpen(false)}
              style={{ transitionDelay: open ? `${120 + i * 60}ms` : "0ms" }}
              className={`py-5 border-b border-[#D4CFC4]/50 font-heading text-2xl italic text-[#2C3029] hover:text-[#9E6D55] transition-all duration-500 ${
                open ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="px-7 mt-2">
          <a
            href={ZEFFY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-drawer-cta-register"
            onClick={() => setOpen(false)}
            className="block w-full text-center px-6 py-4 bg-[#2C3029] text-[#F4F1EA] text-[11px] uppercase tracking-[0.28em] hover:bg-[#9E6D55] transition-colors duration-500"
          >
            Reserve Now
          </a>
          <p className="mt-5 text-[11px] uppercase tracking-[0.25em] text-[#5C6055] text-center">
            October 12–19, 2027 &middot; Zanzibar, Tanzania &middot; 7 nights &middot; 8 days
          </p>
        </div>
      </aside>
    </>
  );
};

export default MobileNavDrawer;
